<div class="container{{ isModal || fullWidth ? '-fluid' : '' }} d-print-none">
  <div class="row">
    <div class="col p-0 d-lg-flex align-items-center justify-content-between w-100">
      @if (showBack) {
        <a (click)="back()"><i class="fa fa-arrow-left"></i>&nbsp;<span i18n>Back</span></a>
      }
      <h2 class="text-nowrap">
        @if (header) {
          <span>{{ header }}</span>
        }
        @if (name && !header) {
          <span>
            {{ menuService.isReadOnly || !this.showSave ? '' : isNewModel(model$ | async) ? createHeader : editHeader }} {{ name }}
          </span>
        }
      </h2>
    </div>
  </div>
    @if (summaryItems || showSaveButton || showAdditionalButtons(model$ | async) || showCopyButton(model$ | async)) {
      <div class="row">
        <div class="col p-0 d-lg-flex align-items-center justify-content-between w-100" [class.mb-3]="!isModal">
          <app-summary [model$]="model$" [summaryItems]="summaryItems"></app-summary>
          <div class="d-flex mt-2 mt-lg-0">
            @if (showAdditionalButtons(model$ | async)) {
              @for (additionalButton of additionalButtons; track additionalButton.text) {
                <button
                  type="button"
                  class="btn btn-{{ additionalButton.cssClass ?? 'info' }} d-flex align-items-center"
                  (click)="additionalButton.click?.()"
                >
                  @if (additionalButton.image) {
                    <img [src]="additionalButton.image" height="16" width="16" alt="" />
                  }
                  @if (additionalButton.icon) {
                    <i class="fa fa-{{ additionalButton.icon }}"></i>
                  }
                  <span>{{ additionalButton.text }}</span>
                </button>
              }
            }
            @if (showCopyButton(model$ | async)) {
              <button type="button" class="btn btn-success" [disabled]="!enableCopyButton" (click)="copyModel.emit()">
                <i class="fa fa-copy"></i> {{ copyButtonText }}
              </button>
            }
            @if (showSaveButton) {
              <button type="button" class="btn btn-primary" (click)="save()">
                <i class="fa fa-save"></i> {{ saveButtonText }}
              </button>
            }
          </div>
        </div>
      </div>
    }
</div>
@if (mobile) {
  <hr />
}
